import React from 'react';
import './Footer.css'; // Assuming you will create a separate CSS file for footer styles

const Footer = () => {
    return (
        <footer className="footer">
            <div className="footer-content">
                <p className="footer-phrase">
                    H’ART ÉLÉGANCE — Maison de Haute Couture de l’Être. Le corps est mémoire. La présence est architecture. L’élégance est révélation.
                    <br/><br/>
                    H’ART ÉLÉGANCE ne vend pas une image. La Maison révèle une architecture intérieure.
                </p>
                <div className="footer-links">
                    <p className="footer-contact"><a href="mailto:h.mour11.11@gmail.com">h.mour11.11@gmail.com</a></p>
                    <p className="footer-contact"><a href="tel:+33749660329">+33 7 49 66 03 29</a></p>
                    <p className="footer-socials">
                        <a href="https://www.linkedin.com/in/hasna-h’art-élégance-ba5325387" target="_blank" rel="noopener noreferrer">LinkedIn</a> | 
                        <a href="https://www.instagram.com/hart_elegance_" target="_blank" rel="noopener noreferrer">Instagram</a> | 
                        <a href="https://youtube.com/@hartelegance" target="_blank" rel="noopener noreferrer">YouTube</a>
                    </p>
                    <p className="footer-location">Savoie / Haute-Savoie</p>
                </div>
                <p className="copyright">© {new Date().getFullYear()} HART ÉLÉGANCE.</p>
            </div>
        </footer>
    );
};

export default Footer;